import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { useDispatch } from "react-redux";
import {
  createTribute,
  getMedallionDetails,
  updateMedallion,
  uploadFile,
} from "../redux/actions/profile";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import Layout from "../components/Layout";
import GalleryModal from "../components/GalleryModal";
import FamilyModal from "../components/FamilyModal";
import TributeSection from "../components/TributeSection";
import { toast } from "react-toastify";
import { MEDALLION_TYPES } from "../constants/medallionTypes";

export default function Profile() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "Biography";
  const [medallionData, setMedallionData] = useState(null);
  const [name, setName] = useState("");
  const [born, setBorn] = useState("");
  const [died, setDied] = useState("");
  const [biographyTitle, setBiographyTitle] = useState("");
  const [biographyContent, setBiographyContent] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerImagePreview, setBannerImagePreview] = useState(null);
  const [showGalleryModal, setShowGalleryModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [showFamilyModal, setShowFamilyModal] = useState(false);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [isGalleryUploading, setIsGalleryUploading] = useState(false);
  const [animatedGifts, setAnimatedGifts] = useState([]);

  // Gift images
  const demoGifts = [
    "https://summerrose-api.bosselt.com/uploads/1765197728056.jpg",
    "https://summerrose-api.bosselt.com/uploads/1765364917312.jpg",
    "https://summerrose-api.bosselt.com/uploads/1765197566690.jpg",
    "https://summerrose-api.bosselt.com/uploads/1765197482037.jpg",
  ];

  const createAnimatedGift = (index) => {
    const directions = [
      "up",
      "down",
      "left",
      "right",
      "upLeft",
      "upRight",
      "downLeft",
      "downRight",
    ];
    const direction = directions[index % directions.length];

    const gift = {
      id: Date.now() + index,
      image: demoGifts[Math.floor(Math.random() * demoGifts.length)],
      direction,
      animationDuration: 8,
      size: Math.random() * 50 + 60,
    };
    return gift;
  };

  const fetchMedallionDetails = async () => {
    try {
      const response = await dispatch(getMedallionDetails(id)).unwrap();
      setMedallionData(response.data);
      setName(response.data?.name || "");
      setBorn(response.data?.born || "");
      setDied(response.data?.died || "");
      setBiographyTitle(response.data?.bio?.title || "");
      setBiographyContent(response.data?.bio?.description || "");
      setGalleryItems(response.data?.gallery || []);
      setFamilyMembers(response.data?.family || []);
    } catch (error) {
      console.error("Error fetching medallion details:", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchMedallionDetails();
    }
  }, [id, dispatch]);

  useEffect(() => {
    const hasGifts = true;

    if (hasGifts) {
      const createAllGifts = () => {
        const gifts = [];
        for (let i = 0; i < 8; i++) {
          gifts.push(createAnimatedGift(i));
        }
        setAnimatedGifts(gifts);

        setTimeout(() => {
          setAnimatedGifts([]);
        }, 8000);
      };

      const interval = setInterval(createAllGifts, 10000);
      createAllGifts();

      return () => clearInterval(interval);
    }
  }, []);

  const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="23"
        viewBox="0 0 32 23"
        fill="none"
        style={{ transform: "rotate(180deg)" }}
      >
        <path
          d="M31.1788 10.2328C31.7506 10.8323 31.7282 11.7818 31.1288 12.3536L21.3607 21.672C20.7612 22.2439 19.8118 22.2215 19.2399 21.6221C18.6681 21.0226 18.6905 20.0732 19.2899 19.5013L27.9727 11.2183L19.6896 2.53548C19.1178 1.93606 19.1401 0.986576 19.7396 0.414749C20.339 -0.157078 21.2885 -0.134708 21.8603 0.464713L31.1788 10.2328ZM0.0351562 10.5601L0.0704864 9.06047L30.1287 9.76865L30.0934 11.2682L30.0581 12.7678L-0.000173899 12.0596L0.0351562 10.5601Z"
          fill="black"
        />
      </svg>
    </div>
  );

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchMedallionDetails = async () => {
      try {
        const response = await dispatch(getMedallionDetails(id)).unwrap();
        setMedallionData(response.data);
      } catch (error) {
        console.error("Error fetching medallion details:", error);
      }
    };

    if (id) {
      fetchMedallionDetails();
    }
  }, [id, dispatch]);

  const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const response = await dispatch(uploadFile(formData)).unwrap();
    return response.data?.image;
  };

  const handleGalleryFilesSelect = (e) => {
    const files = Array.from(e.target.files);
    const fileData = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      type: file.type.startsWith("video/") ? "video" : "image",
    }));
    setSelectedFiles((prev) => [...prev, ...fileData]);
  };

  const removeSelectedFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleGallerySubmit = async () => {
    try {
      setIsGalleryUploading(true);
      const uploadedUrls = [];

      for (const fileData of selectedFiles) {
        const url = await uploadImage(fileData.file);
        uploadedUrls.push(url);
      }

      const updatedGallery = [...galleryItems, ...uploadedUrls];

      await dispatch(
        updateMedallion({
          id,
          data: { gallery: updatedGallery },
        })
      ).unwrap();

      setGalleryItems(updatedGallery);
      setSelectedFiles([]);
      setShowGalleryModal(false);
      toast.success("Gallery updated successfully!");
    } catch (error) {
      console.error("Error updating gallery:", error);
      toast.error("Failed to update gallery");
    } finally {
      setIsGalleryUploading(false);
    }
  };

  const handleFamilySubmit = async (values) => {
    try {
      const newFamilyMember = {
        relation: values.relation,
        name: values.names.filter((name) => name.trim() !== ""),
      };

      const updatedFamily = [...familyMembers, newFamilyMember];

      await dispatch(
        updateMedallion({
          id,
          data: { family: updatedFamily },
        })
      ).unwrap();

      setFamilyMembers(updatedFamily);
      setShowFamilyModal(false);
      toast.success("Family member added successfully!");
    } catch (error) {
      console.error("Error adding family member:", error);
      toast.error("Failed to add family member");
    }
  };

  return (
    <Layout>
      {/* Animated Gifts Overlay */}
      {/* <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 1000,
        overflow: 'hidden'
      }}>
        {animatedGifts.map(gift => (
          <img
            key={gift.id}
            src={gift.image}
            alt="Gift"
            style={{
              position: 'absolute',
              left: '50%',
              top: '300px',
              width: `${gift.size}px`,
              height: `${gift.size}px`,
              animation: `float${gift.direction.charAt(0).toUpperCase() + gift.direction.slice(1)} ${gift.animationDuration}s ease-out forwards`,
              opacity: 0.8,
              borderRadius: '12px',
              transform: 'translate(-50%, -50%)'
            }}
          />
        ))}
      </div> */}

      <section className=" profile-banner-sec-edit">
        <div className="">
          <img
            src={
              medallionData?.banner_image ||
              require("../assets/images/profile-bg.png")
            }
          />
        </div>
      </section>
      <section className="profile-sec-content">
        <Container>
          <div className="profile-sec-data">
            <img
              src={
                medallionData?.profile_image ||
                require(`../assets/images/${
                  medallionData?.type === MEDALLION_TYPES.PET
                    ? "pet.png"
                    : "sarahjohnson.png"
                }`)
              }
            />
            <h2>{medallionData?.name || "N/A"}</h2>
            <ul>
              <li>
                <p>
                  <b>Born :</b>
                  {medallionData?.born || "N/A"}
                </p>
              </li>
              <li>
                <p>
                  <b>Died :</b>
                  {medallionData?.died || "N/A"}
                </p>
              </li>
            </ul>
            <div className="">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeTab}
                onSelect={(key) => setSearchParams({ tab: key })}
              >
                <div className="main-profile-tab">
                  <div className="main-profile-top">
                    <Nav variant="pills" className="respo-main-profile-top">
                      <Nav.Item>
                        <Nav.Link eventKey="Biography">Biography</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="Gallery">Gallery</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="Family">Family</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="Tribute">Tribute</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <div className="main-profile-bottom">
                    <Tab.Content>
                      <Tab.Pane eventKey="Biography">
                        <div className="biography-data">
                          <h4>{medallionData?.bio?.title || "Biography"}</h4>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                medallionData?.bio?.description ||
                                "No biography available.",
                            }}
                          />
                          {/* <p>
                            Evelyn Harper, born on June 14, 1955, in a quaint
                            town in Port Douglas, departed from this world on 13
                            April, 2023, leaving behind a legacy of compassion,
                            resilience, and an unwavering commitment to social
                            justice. Her life, marked by profound dedication to
                            the betterment of society, serves as an enduring
                            testament to the power of kindness and
                            determination.
                          </p>
                          <p>
                            From an early age, Evelyn exhibited an exceptional
                            empathy that would later define her life's work.
                            Growing up in a family of modest means, she was
                            acutely aware of the struggles faced by those around
                            her. This awareness fuelled her desire to effect
                            positive change in her community and beyond. Evelyn
                            pursued her education with fervour, earning a degree
                            in Social Work. Her academic journey was not just a
                            pursuit of knowledge but a quest to understand and
                            address the systemic issues that plagued society.
                            After graduation, she moved to South Australia,
                            where she began her career as a social worker in
                            some of the most underprivileged neighbourhoods. Her
                            work there was transformative, offering support and
                            hope to countless families.
                          </p>
                          <p>
                            In 1985, Evelyn founded the Harper House, a
                            non-profit organization dedicated to providing
                            shelter and resources to homeless women and
                            children. Under her leadership, Harper House became
                            a sanctuary for those in need, offering not just a
                            roof over their heads, but comprehensive support
                            services including job training, counselling, and
                            educational programs. Evelyn’s approach was
                            holistic, understanding that true rehabilitation
                            required addressing both immediate needs and
                            long-term goals. Evelyn’s impact extended beyond her
                            organization. She was a fierce advocate for policy
                            change, working tirelessly to influence legislation
                            related to housing, mental health, and social
                            welfare. Her eloquence and passion made her a
                            formidable voice in the corridors of power, and her
                            efforts resulted in significant policy shifts that
                            improved the lives of many.
                          </p>
                          <p>
                            Despite her professional achievements, Evelyn
                            remained deeply connected to the people she served.
                            She was known for her hands-on approach, often
                            spending time at Harper House, listening to the
                            stories of its residents, and offering personal
                            guidance. Her humility and genuine concern for
                            others earned her the love and respect of all who
                            knew her. Evelyn’s personal life was as rich and
                            fulfilling as her professional one. She was a
                            devoted mother to her two children, Thomas and
                            Laura, whom she raised with the same values of
                            empathy and resilience that she embodied. Her home
                            was a place of warmth and love, where friends and
                            family gathered frequently, drawn by her infectious
                            spirit and boundless generosity.
                          </p>
                          <p>
                            In her later years, Evelyn turned her attention to
                            writing, penning several books on social justice and
                            community building. Her works are widely regarded as
                            essential readings for anyone interested in social
                            work and activism. Through her writing, she
                            continued to inspire and educate future generations,
                            ensuring that her wisdom and compassion would
                            endure. Evelyn Harper’s life was a beacon of hope
                            and resilience. She showed the world that one
                            person’s dedication could make a profound
                            difference, and her legacy will continue to inspire
                            those who strive to create a more just and
                            compassionate society.
                          </p>
                          <p>
                            Though she is no longer with us, her spirit lives on
                            in the countless lives she touched and the positive
                            changes she brought to the world. As we remember
                            Evelyn Harper, we celebrate a life well-lived, a
                            life that made the world a better place. Her memory
                            will forever be a guiding light for those who
                            believe in the power of kindness and the importance
                            of standing up for what is right.
                          </p> */}
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="Gallery">
                        <div className="gallery-data">
                          <div className="gallery-data-head">
                            <button onClick={() => setShowGalleryModal(true)}>
                              Add Images
                            </button>
                            <input
                              type="date"
                              style={{
                                WebkitAppearance: "none",
                                appearance: "none",
                              }}
                            />
                          </div>
                          <div className="gallery-data-photos">
                            {galleryItems
                              ?.filter((item) => item !== null)
                              .map((item, index) => {
                                const isVideo =
                                  item.includes(".mp4") ||
                                  item.includes(".mov") ||
                                  item.includes(".avi") ||
                                  item.includes(".webm");
                                return isVideo ? (
                                  <video
                                    key={index}
                                    src={item}
                                    controls
                                    style={{
                                      width: "100%",
                                      height: "180px",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <img
                                    key={index}
                                    src={item}
                                    alt={`Gallery ${index}`}
                                  />
                                );
                              }) || <p>No gallery items available.</p>}
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="Family">
                        <div className="family-datad-conatin">
                          {/* <div className="mb-3">
                            <button
                              className=""
                              onClick={() => setShowFamilyModal(true)}
                            >
                              Add Family Member
                            </button>
                          </div> */}
                          <div className="d-flex justify-content-between">
                            <div className="w-50 pe-3">
                              <ul>
                                {familyMembers
                                  .filter((_, index) => index % 2 === 0)
                                  .map((member, index) => (
                                    <li key={index} className="mb-3">
                                      <h3>{member.relation}</h3>
                                      {member.name.map((name, nameIndex) => (
                                        <p key={nameIndex}>{name}</p>
                                      ))}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                            <div className="w-50 ps-3">
                              <ul>
                                {familyMembers
                                  .filter((_, index) => index % 2 === 1)
                                  .map((member, index) => (
                                    <li key={index} className="mb-3">
                                      <h3>{member.relation}</h3>
                                      {member.name.map((name, nameIndex) => (
                                        <p key={nameIndex}>{name}</p>
                                      ))}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="Tribute">
                        <TributeSection medallionId={id} />
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </Container>
      </section>

      <GalleryModal
        show={showGalleryModal}
        onHide={() => setShowGalleryModal(false)}
        selectedFiles={selectedFiles}
        onFilesSelect={handleGalleryFilesSelect}
        onRemoveFile={removeSelectedFile}
        onSubmit={handleGallerySubmit}
        isUploading={isGalleryUploading}
      />

      <FamilyModal
        show={showFamilyModal}
        onHide={() => setShowFamilyModal(false)}
        onSubmit={handleFamilySubmit}
      />
    </Layout>
  );
}
